import type { LocalPrintTaskVO } from "@/api/business/types/printing"

export function resolveLocalPrintTaskId(task: LocalPrintTaskVO) {
  return task.taskId ?? task.merchantPrintTaskId ?? null
}
